import {
  Typography,
  Box,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  // Grid,
  // TextField,
} from "@material-ui/core";
import React from "react";
import Footer from "./Footer";
import Header from "./Header";

const imageLocation = process.env.REACT_APP_API_IMAGE;

const TumorMakerOrder = ({ formheader, orderDetails }) => {
  return (
    <>
      <Card variant="outlined">
        <Box display="flex" justifyContent="center">
          <Box mt={2}>
            {formheader && (
              <CardMedia
                style={{ width: 70 }}
                component={"img"}
                src={`${imageLocation}laboratory/logo/${formheader.logo}`}
              />
            )}
          </Box>
          <Box>
            <CardHeader
              component={Box}
              align="center"
              title={
                formheader && (
                  <strong style={{ fontWeight: "bolder", color: "#000" }}>
                    {formheader.name}
                  </strong>
                )
              }
              subheader={
                <Box>
                  <Typography style={{ fontWeight: "bolder", color: "#000" }}>
                    {formheader && formheader.address}
                  </Typography>
                  <Typography style={{ fontWeight: "bolder", color: "#000" }}>
                    {formheader && formheader.contact_number}
                  </Typography>
                </Box>
              }
            />
          </Box>
        </Box>

        {/* <CardContent>
          <Header details={orderDetails} />
        </CardContent> */}

        <CardContent>
          <Box>
            <Header details={orderDetails} />
          </Box>
          <Box>
            <Typography variant="h6" align="center">
              <span
                contentEditable={true}
                suppressContentEditableWarning={true}
                style={{ fontWeight: "bold", color: "#000" }}
              >
                TUMOR MAKER
              </span>
            </Typography>
          </Box>

          <Box>
            {/* order details */}
            <Box>
              {orderDetails.ready ? (
                orderDetails.data.length > 0 ? (
                  orderDetails.data.map((data, key) => {
                    return (
                      <Box my={2} key={key}>
                        <Box mb={3} hidden={!Boolean(parseInt(data.aso))}>
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                <b> ASO </b>
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.aso_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box mb={3} hidden={!Boolean(parseInt(data.biopsy))}>
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                <b> BIOPSY </b>
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.biopsy_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box mb={3} hidden={!Boolean(parseInt(data.c3))}>
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                <b> C3 </b>
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.c3_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box mb={3} hidden={!Boolean(parseInt(data.ca_125))}>
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                <b> CA 125 </b>
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.ca_125_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box mb={3} hidden={!Boolean(parseInt(data.cea))}>
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                <b> CEA </b>
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.cea_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box
                          mb={3}
                          hidden={!Boolean(parseInt(data.psa_prostate))}
                        >
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                <b> PSA Prostate </b>
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.psa_prostate_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box hidden={!Boolean(parseInt(data.afp))}>
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                <b> AFP </b>
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.afp_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    );
                  })
                ) : (
                  <Box>
                    <Typography color="secondary">No record found.</Typography>
                  </Box>
                )
              ) : (
                <Box>
                  <Typography color="primary">
                    loading, please wait...
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>

          <Box my={3} align="center">
            <Footer formheader={formheader} orderDetails={orderDetails} />
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default TumorMakerOrder;
